var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('div', {
    staticClass: "visual"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual__inner"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("Oil & Gas")])])]), _c('p', [_vm._v(" The KIE Systems brings rich experience and unique solution together "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" in the engineering and integration such as analytical instruments. ")])])]), _c('div', {
    staticClass: "swiper-slide__bg swiper-slide__bg--1"
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual__inner"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("Petrochemical")])])]), _c('p', [_vm._v(" The KIE Systems brings rich experience and unique solution together "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" in the engineering and integration such as analytical instruments. ")])])]), _c('div', {
    staticClass: "swiper-slide__bg swiper-slide__bg--2"
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual__inner"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("Power Plant")])])]), _c('p', [_vm._v(" The KIE Systems brings rich experience and unique solution together "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" in the engineering and integration such as analytical instruments. ")])])]), _c('div', {
    staticClass: "swiper-slide__bg swiper-slide__bg--3"
  })])]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual__inner"
  }, [_c('div', {
    staticClass: "text-ani-wrap"
  }, [_c('div', {
    staticClass: "text-ani"
  }, [_c('h2', [_vm._v("Renewable Energy")])])]), _c('p', [_vm._v(" The KIE Systems brings rich experience and unique solution together "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" in the engineering and integration such as analytical instruments. ")])])]), _c('div', {
    staticClass: "swiper-slide__bg swiper-slide__bg--4"
  })])])]), _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-slide__inner"
  }, [_c('div', {
    staticClass: "visual__con"
  }, [_c('div', {
    staticClass: "visual-button-group"
  }, [_c('v-btn', {
    staticClass: "visual-button visual-prev mr-6 mr-lg-10",
    attrs: {
      "icon": "",
      "outlined": "",
      "large": "",
      "color": "rgba(255, 255, 255, 0.25)"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow"
  })]), _c('v-btn', {
    staticClass: "visual-button visual-next",
    attrs: {
      "icon": "",
      "outlined": "",
      "large": "",
      "color": "rgba(255, 255, 255, 0.25)"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow"
  })])], 1), _c('div', {
    staticClass: "visual-pagination text-right"
  })])])])]), _c('div', {
    staticClass: "count-wrap"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "count-group",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "count d-flex flex-column align-center justify-center text-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32"
  }, [_vm._v(" Since 2002 ")]), _c('h2', {
    staticClass: "font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18"
  }, [_c('span', {
    staticClass: "countup"
  }, [_vm._v("20")])]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-1",
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.4)"
    }
  }, [_vm._v(" Years ")])]), _c('v-col', {
    staticClass: "count d-flex flex-column align-center justify-center text-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32"
  }, [_vm._v(" Engineer ")]), _c('h2', {
    staticClass: "font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18"
  }, [_c('span', {
    staticClass: "countup"
  }, [_vm._v("30")]), _vm._v("+")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-1",
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.4)"
    }
  }, [_vm._v(" People ")])]), _c('v-col', {
    staticClass: "count d-flex flex-column align-center justify-center text-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('p', {
    staticClass: "font-size-12 font-size-lg-18 line-height-1 font-weight-bold color-white mb-16 mb-lg-32"
  }, [_vm._v(" Project ")]), _c('h2', {
    staticClass: "font-size-28 font-size-md-50 font-size-lg-72 line-height-1 color-white mb-8 mb-lg-18"
  }, [_c('span', {
    staticClass: "countup"
  }, [_vm._v("1000")]), _vm._v("+")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-18 line-height-1",
    staticStyle: {
      "color": "rgba(255, 255, 255, 0.4)"
    }
  }, [_vm._v(" Times ")])])], 1)], 1)], 1)]), _c('section', {
    staticClass: "main-section main-section1"
  }, [_c('v-container', [_c('h3', {
    staticClass: "main-tit dot-tit"
  }, [_vm._v(" Overseas Owners ")]), _c('v-row', _vm._l(_vm.overseas, function (oversea) {
    return _c('v-col', {
      key: oversea._id,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "3",
        "lg": "2"
      }
    }, [_c('div', {
      staticClass: "logo-thum-wrap"
    }, [_c('div', {
      staticClass: "logo-thum",
      style: "background-image: url(".concat(oversea.thumb, ");")
    })])]);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "main-section main-section2"
  }, [_c('v-container', [_c('h3', {
    staticClass: "main-tit dot-tit"
  }, [_vm._v(" Domestic Business Owners ")]), _c('v-row', _vm._l(_vm.domestics, function (domestic) {
    return _c('v-col', {
      key: domestic._id,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "3",
        "lg": "2"
      }
    }, [_c('div', {
      staticClass: "logo-thum-wrap"
    }, [_c('div', {
      staticClass: "logo-thum",
      style: "background-image: url(".concat(domestic.thumb, ");")
    })])]);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "main-section main-section3"
  }, [_c('v-container', [_c('h3', {
    staticClass: "main-tit dot-tit"
  }, [_vm._v(" EPC ")]), _c('v-row', _vm._l(_vm.epcs, function (epc) {
    return _c('v-col', {
      key: epc._id,
      attrs: {
        "cols": "6",
        "sm": "4",
        "md": "3",
        "lg": "2"
      }
    }, [_c('div', {
      staticClass: "logo-thum-wrap"
    }, [_c('div', {
      staticClass: "logo-thum",
      style: "background-image: url(".concat(epc.thumb, ");")
    })])]);
  }), 1)], 1)], 1), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }